import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { FileText, Clock, MapPin, BookOpen, ShieldCheck, Lock, CreditCard } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-12 md:py-20 px-4 max-w-5xl mx-auto overflow-hidden pt-[10px] pb-[10px]" data-id="element-136">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="flex flex-col items-center text-center" data-id="element-137">
        {/* Eyebrow */}
        <div className="inline-block bg-cream-dark px-4 py-2 rounded-full text-carbon-lighter mb-6 border border-[#E8DCC8] text-xs md:text-sm font-bold tracking-wide" data-id="element-138">
          El sistema de cocina y emprendimiento para familias en Argentina
        </div>

        {/* Title */}
        <h1 className="md:text-5xl lg:text-6xl mb-8 font-serif text-carbon max-w-4xl font-[700] text-[36px]" data-id="element-139">
          De cocinar para la familia a tener tus primeros ingresos extras desde
          tu casa
        </h1>

        {/* Mockup Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative w-full max-w-md md:max-w-lg mb-8" data-id="element-140">
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[110%] h-[110%] bg-cream-dark rounded-full -z-10" data-id="element-141"></div>
          <motion.div animate={{
          y: [0, -10, 0]
        }} transition={{
          repeat: Infinity,
          duration: 5,
          ease: 'easeInOut'
        }} className="relative z-10" data-id="element-142">
            <img src="https://cdn.magicpatterns.com/uploads/gbacM1c5pB6QWrR69zRDbD/Diseno_sin_titulo_(8).png" alt="Mega Pack Cocina" className="w-full h-auto object-contain drop-shadow-2xl" data-id="element-143" />
          </motion.div>
        </motion.div>

        {/* Subtitle */}
        <p className="md:text-lg text-carbon-lighter mb-10 max-w-2xl text-[16px] font-[700]" data-id="element-144">
          Un pack digital de 6 tomos en PDF con recetas, costos y ventas listas
          para usar desde hoy. Sin improvisar. Sin arrancar de cero. Sin horno
          industrial.
        </p>

        {/* Benefits */}
        <div className="grid grid-cols-2 gap-y-4 gap-x-4 mb-10 w-full max-w-lg" data-id="element-145">
          <div className="flex items-center gap-3 text-sm md:text-base font-medium text-carbon" data-id="element-146">
            <div className="bg-brand-green/10 p-2 rounded-lg" data-id="element-147">
              <FileText className="w-5 h-5 text-brand-green flex-shrink-0" data-id="element-148" />
            </div>
            100% PDF
          </div>
          <div className="flex items-center gap-3 text-sm md:text-base font-medium text-carbon" data-id="element-149">
            <div className="bg-brand-green/10 p-2 rounded-lg" data-id="element-150">
              <Clock className="w-5 h-5 text-brand-green flex-shrink-0" data-id="element-151" />
            </div>
            Acceso en minutos
          </div>
          <div className="flex items-center gap-3 text-sm md:text-base font-medium text-carbon" data-id="element-152">
            <div className="bg-brand-green/10 p-2 rounded-lg" data-id="element-153">
              <MapPin className="w-5 h-5 text-brand-green flex-shrink-0" data-id="element-154" />
            </div>
            Hecho para Argentina
          </div>
          <div className="flex items-center gap-3 text-sm md:text-base font-medium text-carbon" data-id="element-155">
            <div className="bg-brand-green/10 p-2 rounded-lg" data-id="element-156">
              <BookOpen className="w-5 h-5 text-brand-green flex-shrink-0" data-id="element-157" />
            </div>
            6 tomos + 3 bonos
          </div>
        </div>

        {/* CTA */}
        <div className="w-full max-w-md" data-id="element-158">
          <CTAButton fullWidth onClick={scrollToPricing} className="mb-5 shadow-warm-lg py-5" data-id="element-159">
            QUIERO ACCEDER AHORA
          </CTAButton>

          <div className="flex flex-wrap justify-center items-center text-xs text-carbon-lighter gap-4" data-id="element-160">
            <div className="flex items-center gap-1.5" data-id="element-161">
              <ShieldCheck className="w-4 h-4 text-brand-green" data-id="element-162" /> Garantía de 7
              días
            </div>
            <div className="flex items-center gap-1.5" data-id="element-163">
              <Lock className="w-4 h-4 text-brand-green" data-id="element-164" /> Pago seguro
            </div>
            <div className="flex items-center gap-1.5" data-id="element-165">
              <CreditCard className="w-4 h-4 text-brand-green" data-id="element-166" /> Mercado Pago
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}